<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<!-- <el-form-item label="客户">
						<el-select filterable v-model="searchInfo.customerId"  placeholder="请选择" :remote-method="getClientList" remote  allow-create learable
						clear style="width: 300px">
							<el-option v-for="it in userList" :key="it.id" :value="it.id"
								:label="it.customerName"></el-option>
						</el-select>
					</el-form-item> -->
                    <el-form-item label="仓库">
						<el-select filterable v-model="searchInfo.warehouseId" style="width: 200px" placeholder="请选择" clear 
						@change="warehouseFocus">
							<el-option v-for="it in warehouseList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品编号" class='tiny'>
						<el-input style="width:300px;" v-model="searchInfo.pdtCode" placeholder="请输入商品编号">
						</el-input>
					</el-form-item>
					<el-form-item label="货物状态" class='tiny'>
						<el-select filterable v-model="searchInfo.stateOfGoodsId" style="width: 200px" placeholder="请选择" clear 
						>
							<el-option v-for="it in stateOfGoodsList" :key="it.id" :value="it.typeKey" :label="it.typeName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button  @click="empty">清空</el-button>
						</template>
					</el-form-item>
					<el-button type="primary" @click="downloadFile"> 导出 </el-button>
				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="expressList" stripe style="width: 100%" border ref="tableRef">
			<el-table-column  prop="warehouseName" label="仓库" align="center" width="150" :show-overflow-tooltip="true" fixed="left">
			</el-table-column>
            <el-table-column prop="pdtCode" label="商品编号" align="center" width="150" :show-overflow-tooltip="true" fixed="left">
			</el-table-column>
			<el-table-column prop="pdtName" label="商品名称" align="center" width="250" fixed="left">
			</el-table-column>
			<el-table-column prop="goodsStatusName" label="货物状态" align="center" width="90" :show-overflow-tooltip="true"
			:formatter="changeGoodsStatus" fixed="left"></el-table-column>
            <el-table-column label="库龄" align="center">
                <el-table-column  prop="january" label="1个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.january">{{scope.row.january}}</span>
                        <span v-else class="tableZero">{{ scope.row.january }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="february" label="2个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.february">{{scope.row.february}}</span>
                        <span v-else class="tableZero">{{ scope.row.february }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="march" label="3个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.march">{{scope.row.march}}</span>
                        <span v-else class="tableZero">{{ scope.row.march }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="april" label="4个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.april">{{scope.row.april}}</span>
                        <span v-else class="tableZero">{{ scope.row.april }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="may" label="5个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.may">{{scope.row.may}}</span>
                        <span v-else class="tableZero">{{ scope.row.may }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="june" label="6个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.june">{{scope.row.june}}</span>
                        <span v-else class="tableZero">{{ scope.row.june }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="july" label="7个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.july">{{scope.row.july}}</span>
                        <span v-else class="tableZero">{{ scope.row.july }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="august" label="8个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.august">{{scope.row.august}}</span>
                        <span v-else class="tableZero">{{ scope.row.august }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="september" label="9个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.september">{{scope.row.september}}</span>
                        <span v-else class="tableZero">{{ scope.row.september }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="october" label="10个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.october">{{scope.row.october}}</span>
                        <span v-else class="tableZero">{{ scope.row.october }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="november" label="11个月" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.november">{{scope.row.november}}</span>
                        <span v-else class="tableZero">{{ scope.row.november }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="december" label="12个月" align="center" width="150">
                     <template slot-scope="scope">
                        <span v-if="scope.row.december">{{scope.row.december}}</span>
                        <span v-else class="tableZero">{{ scope.row.december }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="year1" label="2年" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.year1">{{scope.row.year1}}</span>
                        <span v-else class="tableZero">{{ scope.row.year1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="year2" label="3年" align="center" width="150">
                     <template slot-scope="scope">
                        <span v-if="scope.row.year2">{{scope.row.year2}}</span>
                        <span v-else class="tableZero">{{ scope.row.year2 }}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="year3" label="3年以上" align="center" width="150">
                    <template slot-scope="scope">
                        <span v-if="scope.row.year3">{{scope.row.year3}}</span>
                        <span v-else class="tableZero">{{ scope.row.year3 }}</span>
                    </template>
                </el-table-column>
            </el-table-column>
			
		</el-table>
		<!-- 分页 -->
		<el-pagination style="margin: 20px auto;width:100%;" background :current-page="sliderlist.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="sliderlist.total"
			@size-change="handleSizeChange">
		</el-pagination>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				expressList: [],
				searchInfo: {},
				sliderlist:{},
				storeGoodsInfo: {
					showStatus:true
				},
				dialogVisibleSwiper: false,
                // dialogVisibleSwipers: false
                poupTitle: '',
                addLoading: false,
                editLoading: false,
                
                warehouseId: '',
                districtId: '',
				locationId: '',
				pdtId:'', //商品
                locationList: [],
                warehouseList: [],
                districList: [],
				dataList1: [],
                stateOfGoodsList: [], //货物状态
                
                userList: [],
			}
		},
		methods: {
            changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			changeGoodsStatus(row, column, cellValue) { //处理货物状态
				if (cellValue) {
					// // return cellValue;
					// // this.stateOfGoodsList
					// let obj = {};
					// obj = this.stateOfGoodsList.find((item) => { //这里的userList就是上面遍历的数据源
					// 	return item.typeKey == cellValue; //筛选出匹配数据
					// });
					// return obj.typeName
					// goodsStatus
					return cellValue
				} else {
					if(row.goodsStatus){
						return row.goodsStatus;
					}else{
						return '暂无'
					}
				}
				
			},
			search() { //查询
				this.page.pageNum = 1;
				this.findPmsUnit()
			},
			empty() { //清空
				this.searchInfo = {}
			},
			addDialogClose() {
				this.storeGoodsInfo = {}
            },
            //导出
			downloadFile() {
				let data = {
					warehouseId: this.searchInfo.warehouseId,
					pdtCode: this.searchInfo.pdtCode,
					goodsStatus: this.searchInfo.stateOfGoodsId
				};
				// console.log(data);
				this.$api.storageAgeExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "库龄查询" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			findPmsUnit() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
                    warehouseId: this.searchInfo.warehouseId,
                    // customerId: this.searchInfo.customerId
					// warehouseAreaId: this.searchInfo.districtId,
					// warehouseLocationId: this.searchInfo.LocationId,
					// pdtName: this.searchInfo.pdtName,
					pdtCode: this.searchInfo.pdtCode,
					goodsStatus: this.searchInfo.stateOfGoodsId
				}
				this.$api.storageAgeQueryList(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.expressList = res.data.list
                        this.$nextTick(()=>{
                            this.$refs.tableRef.doLayout();
                        })
                        this.sliderlist = res.data
					}
				})

            },
            warehouseFocus(e){ //仓库选择 - 库区查询
                this.$api.getDistrictListNoParameter({
                    warehouseId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.districList = res.data
					}
				})
            },
            districtFocus(e){ //库区选择 - 库位查询
                this.$api.getLocationListNoParameter({
                    warehouseAreaId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
			},
			inputChange(e) {
				this.dataList1=[]
				this.$api.findgs(this.$encrypt({
					queryParam: e
				})).then(res => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.data.length > 0) {
						res.data.forEach((item,index)=> {
							this.dataList1.push({
								goodsName: item.pdtName,
								goodsId:item.id,
								pdtCode: item.pdtCode,
								unitName: item.unitName,
							})
						})
						// this.flag=true
					} else {
						this.dataList1 = []
					}
					// console.log('dataList1--',this.dataList1)

				})
			},
			goodsClick(e){
				// console.log('234--', e)
			},
			// 新增
			addCarousel() {
                this.storeGoodsInfo = {};
                this.poupTitle = '新增';
                this.warehouseId = '';
                this.districtId = '';
				this.dialogVisibleSwiper = true

			},

			// 提交
			submit() {
                // let data = this.storeGoodsInfo
                this.addLoading = true;
				let data = {
                    warehouseId: this.warehouseId,
                    warehouseAreaId: this.districtId,
					warehouseLocationCode: this.storeGoodsInfo.warehouseLocationCode,
                    warehouseLocationName: this.storeGoodsInfo.warehouseLocationName,
                    warehouseLocationType: this.storeGoodsInfo.warehouseLocationType,
                    useType: this.storeGoodsInfo.useType,

                    warehouseLocationVolume: this.storeGoodsInfo.warehouseLocationVolume,
                    warehouseLocationWeight: this.storeGoodsInfo.warehouseLocationWeight,
                    warehouseLocationLength: this.storeGoodsInfo.warehouseLocationLength,
                    warehouseLocationWidth: this.storeGoodsInfo.warehouseLocationWidth,

                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo
				}
				// console.log(data)
				this.$api.addWarehouseLocationInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.findPmsUnit()
						this.dialogVisibleSwiper = false
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.addLoading = false;
				})

			},

			// 编辑
			editialogVisible(e) {
                // console.log(e)
                this.storeGoodsInfo = {};
                this.warehouseId = '';
                this.districtId = '';
                this.poupTitle = '编辑';
				this.$api.getWarehouseLocationInfoByID(e).then((res) => {
					if (res.state == 'success') {
                        this.storeGoodsInfo = res.data;
                        this.warehouseId =  res.data.warehouseId;
                        this.districtId = res.data.warehouseAreaId;
                        this.storeGoodsInfo.status = res.data.status == 1 ? true : false;
                        this.warehouseFocus(res.data.warehouseId)
						this.dialogVisibleSwiper = true
				
					}
				})

			},
			// 编辑修改提交
			submitClick() {
                this.editLoading = true;
                // let data = this.storeGoodsInfo
                let data = {
					 warehouseId: this.warehouseId,
                    warehouseAreaId: this.districtId,
					warehouseLocationCode: this.storeGoodsInfo.warehouseLocationCode,
                    warehouseLocationName: this.storeGoodsInfo.warehouseLocationName,
                    warehouseLocationType: this.storeGoodsInfo.warehouseLocationType,
                    useType: this.storeGoodsInfo.useType,

                    warehouseLocationVolume: this.storeGoodsInfo.warehouseLocationVolume,
                    warehouseLocationWeight: this.storeGoodsInfo.warehouseLocationWeight,
                    warehouseLocationLength: this.storeGoodsInfo.warehouseLocationLength,
                    warehouseLocationWidth: this.storeGoodsInfo.warehouseLocationWidth,

                    status: this.storeGoodsInfo.status ? 1 : 0,
                    memo: this.storeGoodsInfo.memo,

                    id: this.storeGoodsInfo.id
				}
				this.$api.updateWarehouseLocationInfo(data).then((res) => {
					// console.log(res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwiper = false
						this.findPmsUnit();
						this.storeGoodsInfo = {}
					} else {
						this.$message.error(res.message);
                    }
                    this.editLoading = false;
				})

			},
			// 停用
			toBlockUp(e) {
				// console.log(e)
				var str = "此操作将停用该库位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.locationDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 启用
			toStartUsing(e) {
				// console.log(e)
				var str = "此操作将启用该库位, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.locationDisableAndEnable(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.findPmsUnit();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findPmsUnit();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findPmsUnit()
            },
            getWarehouseLis(){
                this.$api.getWarehouseListNoParameter({
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.warehouseList = res.data
					}
				})
			},
			getStateOfGoodsListI(){ //货物状态查看
                this.$api.getStateOfGoodsList().then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.stateOfGoodsList = res.data
					}
				})
            },
            getClientList(e){
                this.$api.findcusomer(this.$encrypt({
					queryParam: e
				})).then(res => {
                    res.data=JSON.parse(this.$decrypt(res.data)).data
                    this.userList = res.data
                })
            }
		},
		created() {
			// this.findPmsUnit()
			this.getWarehouseLis()
			this.getStateOfGoodsListI()
		}
	}
</script>

<style>
.el-form-item__content{
	margin: 0 !important;
}
.tableZero{
    color:#C0C4CC;
}
</style>
